import { Skeleton, Table } from "@mantine/core";

interface TableSkeletonProps {
  rowNumber: number;
  columnNumber: number;
}

export function TableSkeleton({ rowNumber, columnNumber }: TableSkeletonProps) {
  return Array.from({ length: rowNumber }, (_, rowIndex) => (
    <Table.Tr key={rowIndex}>
      {Array.from({ length: columnNumber }, (_, columnIndex) => (
        <Table.Td key={columnIndex}>
          <Skeleton height={35} radius="xl" />
        </Table.Td>
      ))}
    </Table.Tr>
  ));
}
